// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-collection"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 12.5L19.587 14.8157L22.2797 15.6094L20.5678 17.8343L20.645 20.6406L18 19.7L15.3549 20.6406L15.4321 17.8343L13.7202 15.6094L16.4129 14.8157L18 12.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18 12.5L19.587 14.8157L22.2797 15.6094L20.5678 17.8343L20.645 20.6406L18 19.7L15.3549 20.6406L15.4321 17.8343L13.7202 15.6094L16.4129 14.8157L18 12.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const MapCollectionIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-collection',
    ref,
    icon: element,
  },
));

MapCollectionIcon.displayName = 'MapCollectionIcon';

export default MapCollectionIcon;
